// import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import { AuthContext } from "../../component/context/AuthContext";
// import * as CONST from "../../component/config/Constant";
// import { toast } from "react-toastify";

// import QuizDashboard from "./QuizDashboard";
// import QuizLandingPage from "./QuizLandingPage";
// import QuizActivePage from "./QuizActivePage";

// const QuizManager = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [authUserData] = useContext(AuthContext);

//   const guestUser = location.state?.guestUser || null;
//   const isGuest = !!guestUser;

//   const user = authUserData && authUserData[0] ? authUserData[0] : null;
//   const userId = isGuest
//     ? guestUser.guest_id
//     : user
//       ? user.id || user.user_id
//       : null;

//   const token = user ? user.token : "";

//   const [step, setStep] = useState("dashboard");
//   const [loading, setLoading] = useState(true);
//   const [selectedQuiz, setSelectedQuiz] = useState(null);
//   const [activeQuizzes, setActiveQuizzes] = useState([]);
//   const [completedQuizzes, setCompletedQuizzes] = useState([]);

//   const headers = { Authorization: `Basic ${token}` };

//   // ===============================
//   // INITIAL LOAD LOGIC
//   // ===============================
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const startSetId = params.get("startSet");

//     if (isGuest && startSetId) {
//       fetchGuestQuiz(startSetId);
//     } else if (userId && token) {
//       fetchDashboardData(startSetId);
//     } else {
//       setLoading(false);
//     }
//   }, [userId, token, isGuest, location.search]);

//   // ===============================
//   // FETCH GUEST QUIZ
//   // ===============================
//   const fetchGuestQuiz = async (startSetId) => {
//     try {
//       setLoading(true);
//       const resp = await axios.get(`${CONST.ISO_SET_GET}${startSetId}`);
//       if (resp.data?.status === "success") {
//         const targetSet = resp.data.data;
//         if (targetSet) {
//           const formatted = {
//             ...targetSet,
//             id: targetSet.id || targetSet.question_set_id,
//             title: targetSet.title || "Untitled Quiz",
//             timeLimit: targetSet.time_limit_minutes || 30,
//             questionCount: targetSet.total_questions || 0,
//             questions: (targetSet.questions || []).map((q) => ({
//               ...q,
//               question_options: q.question_options || [],
//             })),
//           };
//           setSelectedQuiz(formatted);
//           setStep("landing");
//         } else toast.error("Quiz not found.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to load quiz details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ===============================
//   // FETCH DASHBOARD DATA
//   // ===============================
//   const fetchDashboardData = async (startSetId = null) => {
//   try {
//     setLoading(true);

//     const assignedUrl = CONST.USER_ASSIGNED_QUIZ.replace(":user_id", userId);
//     const historyUrl = CONST.QUIZ_HISTORY.replace(":user_id", userId).replace("/:set_id", "");

//     const [assignedRes, historyRes] = await Promise.all([
//       axios.get(assignedUrl, { headers }),
//       axios.get(historyUrl, { headers }),
//     ]);

//     // ✅ Fix: Only show quizzes that are actually "active" or "pending"
//     const formattedActive = (assignedRes.data?.data || [])
//       .filter(quiz => quiz.status !== 'completed') // Don't show completed in active section
//       .map((quiz) => ({
//         ...quiz,
//         id: quiz.id || quiz.question_set_id,
//         title: quiz.title || quiz.question_set?.title || "Untitled Quiz",
//         timeLimit: quiz.time_limit_minutes || 30,
//         questionCount: quiz.total_questions || 0,
//         status: quiz.status || "active",
//         score: quiz.score || "N/A", // Use the score from DB if it exists
//       }));
//     setActiveQuizzes(formattedActive);

//     // ✅ Fix: Ensure completed quizzes use the score string from your backend
//     const formattedCompleted = (historyRes.data?.data || []).map((item) => ({
//       ...item,
//       id: item.question_set_id || item.id,
//       title: item.question_set?.title || "General Quiz",
//       total_questions: item.question_set?.total_questions || 0,
//       // Use the score string ("7 / 10") returned by your updated controller
//       score: item.score || "0",
//       status: "completed",
//       date: item.assigned_at
//         ? new Date(item.assigned_at).toLocaleDateString("en-GB")
//         : "N/A",
//     }));
//     setCompletedQuizzes(formattedCompleted);

//     // ... auto-start logic remains the same ...
//   } catch (err) {
//     console.error("Dashboard Load Error:", err);
//     toast.error("Failed to sync dashboard data.");
//   } finally {
//     setLoading(false);
//   }
// };

//   // ===============================
//   // ANSWER HANDLER
//   // ===============================
//   const handleAnswerChange = async (questionId, optionId, quizId) => {
//     try {
//       const targetQuizId = quizId || selectedQuiz?.id;
//       if (!targetQuizId) return;

//       await axios.post(
//         CONST.SUBMIT_ANSWER,
//         {
//           user_id: userId,
//           question_set_id: targetQuizId,
//           question_id: questionId,
//           option_id: optionId,
//           is_guest: isGuest ? 1 : 0,
//         },
//         { headers: !isGuest ? headers : {} },
//       );
//     } catch (err) {
//       console.error("Database sync failed:", err);
//     }
//   };

//   // ===============================
//   // FINAL SUBMIT
//   // ===============================
//   const handleFinalSubmit = async (quizId) => {
//     try {
//       const targetId = quizId || selectedQuiz?.id;
//       if (!targetId) return;

//       await axios.post(
//         CONST.SUBMIT_QUIZ,
//         {
//           user_id: userId,
//           set_id: targetId,
//           is_guest: isGuest ? 1 : 0,
//         },
//         { headers: !isGuest ? headers : {} },
//       );

//       // ✅ Fetch result after submission
//       if (!isGuest) {
//         const resultResp = await axios.get(
//           CONST.QUIZ_RESULT.replace(":user_id", userId).replace(
//             ":set_id",
//             targetId,
//           ),
//           { headers },
//         );
//         if (resultResp.data?.status === "success") {
//           const { total_score, total_questions } = resultResp.data.data;
//           toast.success(
//             `Quiz submitted! Score: ${total_score} / ${total_questions}`,
//           );
//         }
//       }

//       if (isGuest) setStep("completed");
//       else {
//         setSelectedQuiz(null);
//         setStep("dashboard");
//         fetchDashboardData(); // Refresh dashboard with updated score
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Submission failed");
//     }
//   };

//   if (loading)
//     return <div className="p-5 text-center">Loading Quiz Data...</div>;

//   return (
//     <div className="app-wrapper">
//       {step === "dashboard" && (
//         <QuizDashboard
//           allQuizzes={[...activeQuizzes, ...completedQuizzes]}
//           onAnswerSelect={handleAnswerChange}
//           onFinalSubmit={handleFinalSubmit}
//         />
//       )}

//       {step === "landing" && selectedQuiz && (
//         <QuizLandingPage
//           quizData={selectedQuiz}
//           onStart={() => setStep("active")}
//         />
//       )}

//       {step === "active" && selectedQuiz && (
//         <QuizActivePage
//           quizData={selectedQuiz}
//           onAnswerSelect={handleAnswerChange}
//           onComplete={handleFinalSubmit}
//           guestUser={guestUser}
//         />
//       )}

//       {step === "completed" && isGuest && (
//         <div className="container-xl mt-5 text-center p-5 bg-white shadow-sm rounded">
//           <h2 className="fw-bold mb-3">Assessment Submitted!</h2>
//           <p className="text-muted mb-4">
//             Thank you, <strong>{guestUser.name}</strong>. Your responses for
//             <strong> {selectedQuiz?.title}</strong> have been recorded.
//           </p>
//           <button
//             className="btn btn-primary px-4 py-2"
//             onClick={() => navigate("/")}
//           >
//             Go to Home
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default QuizManager;
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../component/context/AuthContext";
import * as CONST from "../../component/config/Constant";
import { toast } from "react-toastify";

import QuizDashboard from "./QuizDashboard";
import QuizLandingPage from "./QuizLandingPage";
import QuizActivePage from "./QuizActivePage";
import { decrypt } from "./Helper";

const QuizManager = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [authUserData] = useContext(AuthContext);

  // GUEST Logic
  const guestUser = location.state?.guestUser || null;
  const isGuest = !!guestUser;

  const user = authUserData && authUserData[0] ? authUserData[0] : null;
  const userId = isGuest
    ? guestUser.guest_id
    : user
      ? user.id || user.user_id
      : null;
  const token = user ? user.token : "";

  const [step, setStep] = useState(isGuest ? "active" : "dashboard");
  const [loading, setLoading] = useState(true);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [activeQuizzes, setActiveQuizzes] = useState([]);
  const [completedQuizzes, setCompletedQuizzes] = useState([]);

  const headers = { Authorization: `Basic ${token}` };

  useEffect(() => {
    if (isGuest) {
      const params = new URLSearchParams(location.search);
      const rawStartSetId = params.get("startSet");
      const startSetId = decrypt(rawStartSetId) || rawStartSetId;

      const fetchGuestQuiz = async () => {
        try {
          setLoading(true);
          const resp = await axios.get(`${CONST.ISO_SET_GET}${startSetId}`);
          if (resp.data && resp.data.status === "success") {
            const targetSet = resp.data.data;
            if (targetSet) {
              const formatted = {
                ...targetSet,
                id: targetSet.id || targetSet.question_set_id,
                title: targetSet.title || "Untitled Quiz",
                timeLimit: targetSet.time_limit_minutes || 30,
                questionCount: targetSet.total_questions || 0,
                questions: (targetSet.questions || []).map((q) => ({
                  ...q,
                  question_options: q.question_options || [],
                })),
              };
              setSelectedQuiz(formatted);
              // 🔹 CHANGE 2: Ensure guest stops at landing page
              setStep("landing");
            } else {
              toast.error("Quiz not found.");
            }
          }
        } catch (err) {
          console.error(err);
          toast.error("Failed to load quiz details.");
        } finally {
          setLoading(false);
        }
      };

      if (startSetId) fetchGuestQuiz();
      else setLoading(false);
    } else if (userId && token) {
      fetchDashboardData();
    } else if (authUserData !== undefined && !userId) {
      setLoading(false);
    }
  }, [userId, token, isGuest]);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const headers = { Authorization: `Basic ${token}` };

      const assignedUrl = CONST.USER_ASSIGNED_QUIZ.replace(":user_id", userId);

      const historyUrl = CONST.QUIZ_HISTORY.replace(":user_id", userId).replace(
        "/:set_id",
        "",
      );

      const [assignedRes, historyRes] = await Promise.all([
        axios.get(assignedUrl, { headers }),
        axios.get(historyUrl, { headers }),
      ]);

      // Inside QuizManager.js -> fetchDashboardData
      if (assignedRes.data && assignedRes.data.status === "success") {
        const rawQuizzes = assignedRes.data.data || [];

        // DEBUG LOG: Look at this in the browser console (F12)
        console.log("RAW API DATA:", rawQuizzes);

        const formattedActive = rawQuizzes.map((quiz) => ({
          ...quiz,
          // Ensure these IDs match what comes from your database
          id: quiz.id || quiz.question_set_id,
          title: quiz.title || quiz.question_set?.title || "Untitled Quiz",
          timeLimit: quiz.time_limit_minutes || 30,
          questionCount: quiz.total_questions || 0,
        }));

        setActiveQuizzes(formattedActive);
      }

      // ✅ COMPLETED QUIZZES (SCORE FIXED HERE)
      if (historyRes.data && historyRes.data.status === "success") {
        const rawHistory = historyRes.data.data || [];

        const formattedHistory = await Promise.all(
          rawHistory.map(async (item) => {
            try {
              // 🔥 Fetch detailed history for this set
              const detailUrl = CONST.QUIZ_HISTORY.replace(
                ":set_id",
                item.question_set_id,
              ).replace(":user_id", userId);

              const detailRes = await axios.get(detailUrl, { headers });

              let totalQuestions = 0;
              let totalScore = 0;

              if (detailRes.data.status === "success") {
                const questions = detailRes.data.data || [];

                totalQuestions = questions.length;
                totalScore = questions.filter((q) => q.is_correct).length;
              }

              return {
                id: item.id,
                title: item.question_set?.title || "General Quiz",
                date: item.assigned_at
                  ? new Date(item.assigned_at).toLocaleDateString()
                  : "N/A",
                score: `${totalScore}/${totalQuestions}`, // ✅ CORRECT SCORE
                status: item.status,
              };
            } catch (err) {
              return {
                id: item.id,
                title: item.question_set?.title || "General Quiz",
                date: "N/A",
                score: "0/0",
                status: item.status,
              };
            }
          }),
        );

        setCompletedQuizzes(formattedHistory);
      }
    } catch (err) {
      console.error("Dashboard Load Error:", err.response?.data || err.message);
      setActiveQuizzes([]);
      setCompletedQuizzes([]);
      toast.error("Failed to sync dashboard data.");
    } finally {
      setLoading(false);
    }
  };

  // Auto-start quiz if ?startSet=ID is present
  useEffect(() => {
    if (!loading && activeQuizzes.length > 0 && !isGuest) {
      const params = new URLSearchParams(location.search);
      const rawStartSetId = params.get("startSet");
      const startSetId = decrypt(rawStartSetId) || rawStartSetId;

      if (startSetId) {
        const quizToStart = activeQuizzes.find(
          (q) => String(q.id) === String(startSetId),
        );
        if (quizToStart) {
          if (quizToStart.status === "completed") {
            toast.info("This quiz is already completed.");
          } else {
            setSelectedQuiz(quizToStart);
            // 🔹 Ensure logged in users also hit landing page first
            setStep("landing");
          }
        }
      }
    }
  }, [loading, activeQuizzes, location.search, isGuest]);
  // Inside QuizManager.js
  const handleAnswerChange = async (questionId, optionId, quizId) => {
    try {
      // If quizId isn't passed, try to fallback, but now we have a direct source
      const targetQuizId = quizId || selectedQuiz?.id;

      if (!targetQuizId) {
        console.error("Sync Error: No Quiz ID found");
        return;
      }

      return await axios.post(
        CONST.SUBMIT_ANSWER,
        {
          user_id: userId,
          question_set_id: targetQuizId, // Use the ID passed from the component
          question_id: questionId,
          option_id: optionId,
          is_guest: isGuest ? 1 : 0,
        },
        { headers: !isGuest ? { Authorization: `Basic ${token}` } : {} },
      );
    } catch (err) {
      console.error("Database sync failed:", err);
    }
  };

  // Inside QuizManager.js
  const handleFinalSubmit = async (quizId) => {
    try {
      // Fallback to selectedQuiz.id if quizId isn't passed
      const targetId = quizId || selectedQuiz?.id;

      if (!targetId) {
        toast.error("Quiz ID missing. Cannot submit.");
        return;
      }

      const resp = await axios.post(
        CONST.SUBMIT_QUIZ,
        {
          user_id: userId,
          set_id: targetId, // Use the ID passed from the component
          is_guest: isGuest ? 1 : 0,
        },
        { headers: !isGuest ? { Authorization: `Basic ${token}` } : {} },
      );

      if (resp.data.status === "success") {
        toast.success("Thank you for submitting");
        if (isGuest) {
          setStep("completed");
        } else {
          setStep("dashboard");
          setSelectedQuiz(null);
          fetchDashboardData(); // Refresh scores
        }
      }
    } catch (err) {
      console.error("Submission error details:", err.response?.data);
      toast.error(err.response?.data?.message || "Submission failed");
    }
  };
  if (loading)
    return <div className="p-5 text-center">Loading Quiz Data...</div>;
  return (
    <div className="app-wrapper">
      {step === "dashboard" && (
        <QuizDashboard
          allQuizzes={[...activeQuizzes, ...completedQuizzes]}
          // Pass these functions directly as individual props
          onAnswerSelect={handleAnswerChange}
          onFinalSubmit={handleFinalSubmit}
        />
      )}

      {/* Keep step landing as a fallback if needed */}
      {step === "landing" && (
        <QuizLandingPage
          quizData={selectedQuiz}
          onStart={() => setStep("active")}
          onBack={() => setStep("dashboard")}
        />
      )}

      {step === "active" && (
        <QuizActivePage
          quizData={selectedQuiz}
          onAnswerSelect={handleAnswerChange}
          onComplete={handleFinalSubmit}
          guestUser={guestUser}
        />
      )}

      {step === "completed" && isGuest && (
        <div className="container-xl mt-5 text-center p-5 bg-white shadow-sm rounded">
          <div className="mb-4">
            <i
              className="fa fa-check-circle text-success"
              style={{ fontSize: "5rem" }}
            ></i>
          </div>
          <h2 className="fw-bold mb-3">Assessment Submitted!</h2>
          <p className="text-muted mb-4">
            Thank you, <strong>{guestUser.name}</strong>. Your responses for
            <strong> {selectedQuiz?.title}</strong> have been successfully
            recorded.
          </p>
          <button
            className="btn btn-primary px-4 py-2"
            onClick={() => navigate("/")}
          >
            Go to Home
          </button>
        </div>
      )}
    </div>
  );
};

export default QuizManager;